import React, { useState, useEffect } from 'react';
import ListSubCategory from '../../../components/Admin/SubCategory/ListSubCategory';
import AddEditSubCatForm from '../../../components/Admin/SubCategory/AddEditSubCatForm';
import Modal from "../../../components/Modal";
import { getSubCategoriesApi, getSubCategoriesDetaApi } from '../../../api/subcategory';
import { getCatWithoutNotesApi } from '../../../api/category'
import { errorModal, warningModal } from '../../../components/Alerts/Alerts';


export default function SubCategory() {
    const [ subCategories, setSubCategories ] = useState([]);
    const [ reloadSubCategories, setReloadSubCategories ] = useState(false);
    const [ subCategoriesDeta, setSubCategoriesDeta ] = useState([]);
    const [ reloadSubCategoriesDeta, setReloadSubCategoriesDeta ] = useState(false);
    const [ subCategoriesBase, setSubCategoriesBase ] = useState(null);
    const [ reloadsubCategoriesBase, setReloadsubCategoriesBase ] = useState(false);
    const [ categories, setCategories ] = useState([]);
    const [ reloadCategories, setReloadCategories ] = useState(false);
    const [ isVisibleModal, setIsVisibleModal ] = useState(false);
    const [ modalTitle, setModalTitle ] = useState("");
    const [ modalContent, setModalContent ] = useState(null);

    useEffect(() => {
        getSubCategoriesApi().then(response => {
            setSubCategories(response.subCategory);
        });

        setReloadSubCategories(false);
    }, [reloadSubCategories]);

    useEffect(() => {
        getSubCategoriesDetaApi().then(response => {
            setSubCategoriesDeta(response.subCategory);
        });

        setReloadSubCategoriesDeta(false);
    }, [reloadSubCategoriesDeta]);

    useEffect (() => {
        getSubCategoriesApi()
            .then(response => {
                if (response.code && response.code !== 200){
                    warningModal("Advertencia", response.message);
                }else{
                    setSubCategoriesBase(response.subCategory);
                }
            })
            .catch(err => {
                errorModal	("Error", "Error del Servidor.");
            });
            setReloadsubCategoriesBase(false);
    }, [reloadsubCategoriesBase]);

    useEffect(() => {
        getCatWithoutNotesApi().then(response => {
            setCategories(response.category);
        });

        setReloadCategories(false);
    }, [reloadCategories]);

    const editSubCat = subCategories => {
        setIsVisibleModal(true);
        setModalTitle("Editar Subcategoría");
        setModalContent(
                <AddEditSubCatForm
                    setIsVisibleModal={setIsVisibleModal}
                    setReloadSubCategories={setReloadSubCategories}
                    subCategories={subCategories}
                    subCategoriesBase={Array.isArray(subCategoriesBase) && subCategoriesBase.find(el => el._id === subCategories._id)}
                    setReloadsubCategoriesBase={setReloadsubCategoriesBase}
                    categories={categories}
                    setReloadSubCategoriesDeta={setReloadSubCategoriesDeta}
                />
            );
    }

    const newSubcategory = e => {
        setIsVisibleModal(true);
        setModalTitle("Nueva Subcategoría");
        setModalContent(
                <AddEditSubCatForm
                    setIsVisibleModal={setIsVisibleModal}
                    setReloadSubCategories={setReloadSubCategories}
                    subCategories={null}
                    subCategoriesBase={null}
                    setReloadsubCategoriesBase={setReloadsubCategoriesBase}
                    categories={categories}
                    setReloadSubCategoriesDeta={setReloadSubCategoriesDeta}
                />
            );
    }

    return (
        <div>
            <ListSubCategory 
                subCategories={subCategories} 
                setReloadSubCategories={setReloadSubCategories}
                subCategoriesBase={subCategoriesBase}
                editSubCat={editSubCat}
                newSubcategory={newSubcategory}
                subCategoriesDeta={subCategoriesDeta}
                setReloadSubCategoriesDeta={setReloadSubCategoriesDeta}
            />

            <Modal
                title={modalTitle}
                isVisible={isVisibleModal}
                setIsVisible={setIsVisibleModal}
                setSize='md'
            >
                {modalContent}
            </Modal>
        </div>

        
    )
}
